module.exports = __webpack_public_path__ + "img/Differentiation-GBM_10X_TPCP.e02ca7fe.png";